import { render } from "./PlayoutSidebar.vue?vue&type=template&id=9ea48b6e"
import script from "./PlayoutSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutSidebar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ea48b6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ea48b6e', __exports__)) {
    api.reload('9ea48b6e', __exports__)
  }
  
  module.hot.accept("./PlayoutSidebar.vue?vue&type=template&id=9ea48b6e", () => {
    api.rerender('9ea48b6e', render)
  })

}


export default __exports__